import { find } from "lodash";
import { AbstractDate, Interval } from "@linkfluence/models/date";
import { Timezone } from "@linkfluence/models/timezone";
import { isSame } from "@tootools/date";

export interface Milestone {
  description: string;
  endDate: AbstractDate;
  id: number;
  imageUrl: string;
  interval: Interval;
  name: string;
  startDate: AbstractDate;
  timezone: Timezone;
}

export function getMilestone(
  from: AbstractDate,
  to: AbstractDate,
  milestones: Milestone[]
): Milestone {
  return find(
    milestones,
    (milestone) =>
      isSame(from, milestone.startDate) && isSame(to, milestone.endDate)
  );
}
